export default __webpack_public_path__ + "static/media/logo-branco.316f78a8.png";